module.exports = __webpack_public_path__ + "img/20210906-1630911182117733.98ad8090.jpg";